<template>
  <div style="height: 100vh;min-height: 685px;" class="wx-login-bind-account">
    <div class="centen">
      <!--用户重置密码-->
      <div class="accountEntry" >
        <h5><i class="el-icon-info"></i> 请选择您的账号，首次登录平台需输入您的账号及密码</h5>
        <div v-if="!addNewAccount">
          <div class="account-box" >
            <div v-if="accountList.length === 0" style="color: #999999;line-height: 80px">暂无关联账号</div>
            <div v-for="item in accountList" :class="[item.code===accountData.code ? 'account-line2' : 'account-line']" @click="chooseAccount(item)">
              <img v-if="item.yqIconUrl" :src="item.yqIconUrl" alt="yqLogo" class="account-logo">
              <img v-if="!item.yqIconUrl" src="/housingStatic/favicon4.ico" alt="yqLogo" class="account-logo">
              <div class="account-info">
                <div class="account-info-name">{{item.name}}</div>
                <div class="account-info-yqName">{{item.yqName}}</div>
              </div>
              <i class="el-icon-check" v-if="item.code===accountData.code"></i>
            </div>
          </div>
          <div class="confirm-login" @click="confirmLogin" v-if="accountList.length > 0">确定</div>
          <div class="add-new-account" @click="showAddNewAccountBox">添加新账号 <i class="el-icon-d-arrow-right"></i></div>
        </div>


        <ul v-if="addNewAccount">
          <li>
            <el-input placeholder="公寓名称" prefix-icon="el-icon-damai-yuanqu" v-model="yqAppCode" size="mini" @keyup.enter.native="login" />
          </li>
          <li>
            <el-input placeholder="用户名" prefix-icon="el-icon-damai-yonghu" v-model="name" size="mini" @keyup.enter.native="login" />
          </li>
          <li>
            <el-input placeholder="密码" prefix-icon="el-icon-damai-weibaoxitongshangchuanlogo" v-model="password" type="password" size="mini" @keyup.enter.native="login" />
          </li>
          <li style="margin-top: 40px">
            <a @click="hideAddNewAccountBox" class="btn-return">返回</a>
            <a @click="changePassword" class="btn">确认</a>
          </li>
        </ul>
      </div>
    </div>
    <footer>Copyright © 2017，Damai-IoT，All Rights Reserved | 浙ICP备18001529号</footer>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  import {bus} from '../../utils/bus'
  import {nError, nSuccess} from '../../utils/notice'
  import {pattern} from '../../utils/regular'
  import {errorHandler} from '../../utils/errorHandler'
  import {api} from '../api/Login'

  export default {
    name: 'wx-login-bind-account',
    data () {
      return {
        accountList: [],
        accountData: {},
        addNewAccount: false,

        yqAppCode: '',
        name: '',
        password: '',
        wxUnionid: '',
      }
    },
    created () {
      let code = this.$route.query.code
      if (code) {
        this.getAccountByWx(code)
      } else {
        this.toLoginPage()
      }
    },
    methods: {
      toLoginPage: function () {
        this.$router.push({
          name: 'login'
        })
      },
      toHomepage () {
        window.sessionStorage.setItem('navTop', 'workbench')
        this.$router.push({
          name: 'workbench'
        })
      },
      // 查询微信关联账号列表
      getAccountByWx (code) {
        this.$axios.get(`${api.getAccountByWx}/${code}`, {})
          .then(res => {
            let data = res.data.data
            this.wxUnionid = data[0].wxUnionid
            let accountList = []
            data.map(v => {
              if (v.code) {
                accountList.push(v)
              }
            })
            this.accountList = accountList
            if (this.accountList.length === 0) {
              this.addNewAccount = true
            }
          })
          .catch(errorHandler('查询失败'))
      },
      toyqInfoPage () {
        let routerName = ''
        window.sessionStorage.setItem('navTop', 'resource')
        if (bus.global.permissionCodes.indexOf('001001000') !== -1) {
          routerName = 'yq-information'
        } else if (bus.global.permissionCodes.indexOf('001002000') !== -1) {
          routerName = 'yq-notice-management'
        } else if (bus.global.permissionCodes.indexOf('001002004') !== -1) {
          routerName = 'yq-video-management'
        } else if (bus.global.permissionCodes.indexOf('001003000') !== -1) {
          routerName = 'housing-management'
        } else if (bus.global.permissionCodes.indexOf('001004000') !== -1) {
          routerName = 'business-management'
        } else if (bus.global.permissionCodes.indexOf('001005000') !== -1) {
          routerName = 'person-management'
        } else if (bus.global.permissionCodes.indexOf('001006000') !== -1) {
          routerName = 'config-card'
        } else if (bus.global.permissionCodes.indexOf('001007000') !== -1) {
          routerName = 'account-management'
        } else if (bus.global.permissionCodes.indexOf('001008000') !== -1) {
          routerName = 'role-management'
        } else if (bus.global.permissionCodes.indexOf('001009000') !== -1) {
          routerName = 'ali-config'
        } else if (bus.global.permissionCodes.indexOf('001009004') !== -1) {
          routerName = 'config-routine'
        } else if (bus.global.permissionCodes.indexOf('001009006') !== -1) {
          routerName = 'config-card-type'
        } else if (bus.global.permissionCodes.indexOf('001010000') !== -1) {
          routerName = 'resource-center-log'
        } else if (bus.global.permissionCodes.indexOf('002001000') !== -1) {
          routerName = 'custom-management'
        } else if (bus.global.permissionCodes.indexOf('003001000') !== -1) {
          routerName = 'accessCtrlDeviceManagementCenter'
        } else if (bus.global.permissionCodes.indexOf('004001000') !== -1) {
          routerName = 'parking-device-management'
        } else if (bus.global.permissionCodes.indexOf('005001000') !== -1) {
          routerName = 'controller-management'
        } else if (bus.global.permissionCodes.indexOf('007004000') !== -1) {
          routerName = 'visitor-device-manage'
        } else if (bus.global.permissionCodes.indexOf('008001000') !== -1) {
          routerName = 'site-management'
        } else if (bus.global.permissionCodes.indexOf('009001000') !== -1) {
          routerName = 'ladder-device'
        } else if (bus.global.permissionCodes.indexOf('011001000') !== -1) {
          routerName = 'repair-category-manage'
        } else if (bus.global.permissionCodes.indexOf('002007000') !== -1) {
          routerName = 'needHandle'
        } else {
          routerName = 'workbench'
        }
        this.$router.push({
          name: routerName
        })
      },

      // 展示添加账号页面
      showAddNewAccountBox () {
        this.accountData = {}
        this.addNewAccount = true
      },

      // 隐藏添加账号页面
      hideAddNewAccountBox () {
        this.yqAppCode = ''
        this.name = ''
        this.password = ''
        this.addNewAccount = false
      },
      // 选择账号
      chooseAccount (accountData) {
        this.accountData = accountData
      },
      // 选择账号登录
      confirmLogin () {
        if (!this.accountData.code) {
          nError('请选择账号')
          return false
        }
        let yqCode = this.accountData.yqAppCode
        this.$axios.post(`${api.chooseAccountThenLogin}`, this.accountData)
          .then(res => {
            let data = res.data.data

            window.sessionStorage.setItem('accountCode', data.code)
            window.sessionStorage.setItem('accountName', data.name)
            window.sessionStorage.setItem('accountPersonCode', data.personCode)
            window.sessionStorage.setItem('accountPersonName', data.personName)
            window.sessionStorage.setItem('token', data.token)
            window.sessionStorage.setItem('permissionCodes', data.permissionCodes)
            window.sessionStorage.setItem('yqCode', yqCode)
            bus.global.accountCode = data.code
            bus.global.accountName = data.name
            bus.global.personCode = data.personCode
            bus.global.personName = data.personName
            bus.global.token = data.token
            bus.global.yqCode = yqCode
            bus.global.permissionCodes = data.permissionCodes

            if (data.isFirstTime === '1') {
              if (data.permissionCodes.indexOf('000000000') === -1) {
                this.toyqInfoPage()
              } else {
                this.toHomepage()
              }
            } else {
              window.sessionStorage.setItem('firstChangeOldPassword', '')
              this.$router.push({
                name: 'first-change-password'
              })
            }
          })
          .catch(errorHandler('查询失败'))
      },

      changePassword () {
        let checkPassword = pattern.password.test(this.password)
        if (!this.password) {
          nError('请输入密码')
          return false
        } else {
          if (!checkPassword) {
            nError('请输入8至20位无特殊字符的密码')
            return false
          }
        }
        let name = this.name.toLowerCase()
        let newpw = this.password + name
        let newonce = md5(newpw) + name
        let newpwd
        for (let i = 0; i < 9; i++) {
          newpwd = md5(newonce)
          newonce = newpwd + name
        }
        this.$axios.post(api.bindAccountThenLogin, {
          yqAppCode: this.yqAppCode,
          name: this.name,
          password: newpwd,
          wxUnionid: this.wxUnionid
        })
          .then(res => {
            let data = res.data.data

            window.sessionStorage.setItem('accountCode', data.code)
            window.sessionStorage.setItem('accountName', data.name)
            window.sessionStorage.setItem('token', data.token)
            window.sessionStorage.setItem('permissionCodes', data.permissionCodes)
            window.sessionStorage.setItem('yqCode', this.yqAppCode)
            bus.global.accountCode = data.code
            bus.global.accountName = data.name
            bus.global.token = data.token
            bus.global.yqCode = this.yqAppCode
            bus.global.permissionCodes = data.permissionCodes

            if (data.isFirstTime === '1') {
              if (data.permissionCodes.indexOf('000000000') === -1) {
                this.toyqInfoPage()
              } else {
                this.toHomepage()
              }
            } else {
              window.sessionStorage.setItem('firstChangeOldPassword', newpwd)
              this.$router.push({
                name: 'first-change-password'
              })
            }
          })
          .catch(errorHandler('登录失败'))
      },
    }
  }
</script>

<style scoped>
  .head img {
    width: 250px;
    height: 44px;
    margin: 15px 10px 15px 30px;
  }
  .centen {
    width: 100%;
    height: 90%;
    background-color: #EFF1F5;
    position: relative;
  }
  .accountEntry {
    width: 520px;
    height: 360px;
    padding: 20px;
    position: absolute;
    top: 120px;
    left: 0;
    right: 0;
    margin: 0 auto;
    background: white;
    border: 1px solid #E6E6E6;
  }

  h5 {
    color: #4D4D4D;
    font-weight: 400;
    margin: 0;
    padding-bottom: 15px;
    border-bottom: 1px solid #eeeeee;
  }

  h5 i {
    color: #00A0E6;
  }

  .code-li .el-input {
    width: 180px;
  }

  #user_phone {
    margin-left: 10px;
    width: 160px;
    text-align: left;
    color: #00A0E6;
  }

  .accountEntry li {
    padding: 0 33px;
    margin-top: 25px;
    text-align: left;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .accountEntry li span {
    display: inline-block;
    width: 60px;
    text-align: right;
  }

  .accountEntry li:last-child {
    display: flex;
    justify-content: space-between;
    padding: 0 60px;
  }

  .prompt b {
    display: block;
    width: 100%;
    text-align: center;
    color: red;
    margin-top: 8px;
    margin-bottom: -5px;
  }

  .btn {
    display: block;
    width: 90px;
    margin: 0 auto;
    color: #FFFFFF;
    border-radius: 5px;
    text-align: center;
    background-color: #00A0E6;
    padding: 5px 10px;
  }
  .btn-return {
    display: block;
    width: 90px;
    margin: 0 auto;
    color: #999999;
    border-radius: 5px;
    border: 1px solid #cccccc;
    text-align: center;
    background-color: #ffffff;
    padding: 5px 10px;
  }

  .el-input {
    margin-left: 10px;
    width: 80%;
  }

  footer {
    width: 100%;
    font-size: 13px;
    text-align: center;
    color: #999999;
    background-color: #F0F3F7;
    height: 10vh;
    line-height: 35px;
  }
</style>

<style lang="less">
  .wx-login-bind-account {
    .accountEntry {
      .account-box {
        height: 200px;
        overflow-y: auto;
        margin: 10px auto;
        .account-line, .account-line2 {
          width: 300px;
          display: flex;
          justify-content: flex-start;
          margin: 20px auto;
          padding: 10px;
          border-radius: 10px;
          border: 1px solid #eeeeee;
          cursor: pointer;
          .account-logo {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin: 0 20px 0 10px;
          }
          .account-info {
            flex: 1;
            text-align: left;
            .account-info-name {
              font-size: 24px;
              color: #333333;
              line-height: 30px;
            }
            .account-info-yqName {
              color: #999999;
              line-height: 20px;
            }
          }
        }

        .account-line2 {
          border: 1px solid #00a0e6;
          position: relative;
          .el-icon-check {
            font-size: 20px;
            position: absolute;
            bottom: 5px;
            right: 5px;
            color: #00a0e6;
          }
        }
      }

      .confirm-login {
        cursor: pointer;
        width: 260px;
        height: 36px;
        margin: 20px auto 0;
        line-height: 36px;
        background-color: #00a0e6;
        color: #ffffff;
        border-radius: 10px;
      }

      .add-new-account {
        text-align: right;
        cursor: pointer;
        color: #00a0e6;
        line-height: 26px;
        position: absolute;
        bottom: 5px;
        right: 10px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/WxLogin/WxLoginBindAccount.vue